module.exports = __webpack_public_path__ + "static-v-shop/1765574342361/img/frame.442faa53.webp";